import {ICleanup} from '../../Utils/CommonTypes';
import {IPreloader} from './IPreloader';
import {PreloaderResourceItem} from './PreloaderResourceItem';

export abstract class PreloaderResourceLoader implements ICleanup {
    protected preloader: IPreloader;
    protected audio: boolean;

    public get isAudioLoader() {
        return this.audio;
    }

    protected constructor(audio: boolean) {
        this.audio = audio;
    }

    public init(preloader: IPreloader): void {
        this.preloader = preloader;
    }

    protected updateProgress(loaded: number): void {
        this.preloader.updateProgress(loaded);
    }

    public cleanup(): void {
        this.preloader = null;
    }

    /**
     * @method xmlsResourceLoaded - called when xml file was loaded by preloader
     * @param document
     */
    public xmlsResourceLoaded(document: XMLDocument, resource: PreloaderResourceItem): void
    {}

    /**
     * @method beforeResourcesLoad - invoked before resources area loaded
     * @summary usefull to prepare loader before actual loading process begins
     */
    abstract beforeResourcesLoad(): void;

    abstract loadAllGroupsCompleted(): void;

    /**
     * @method loadResources - loads list of resources
     * @param resources - list of resources to be loaded
     * @param resolveCallback - callback to be called when load process ends
     */
    abstract loadResources(resources: Array<PreloaderResourceItem>, resolveSingleCallback: Function, resolveCallback: Function): void;
}


/** WEBPACK FOOTER **
 ** ./Engine/Preloader/Types/PreloaderResourceLoader.ts
 **/